import { Routes, Router } from '@angular/router';
const ɵ0 = () => import("./info-page/info-page.module.ngfactory").then(m => m.InfoPageModuleNgFactory), ɵ1 = () => import("./details-page/details-page.module.ngfactory").then(m => m.DetailsPageModuleNgFactory);
const routes = [
    { path: '', loadChildren: ɵ0 },
    { path: 'member', loadChildren: ɵ1, pathMatch: 'full' }
];
export class MembersRoutingModule {
    constructor(router) {
    }
}
export { ɵ0, ɵ1 };
